import { useEffect, useState, useRef } from 'react'
import { KTSVG } from '../../_metronic/helpers'
// import { useQueryRequest } from './request'
import { getUserTypeList, downloadByUserType } from '../company-module/api'
import { Downloadloader, downloadCsv } from './helper'

// Download filter component for user type
/**
 * DwonloadFilter
 *
 * Renders a filter and download button for user types, allowing CSV download by selected type.
 * Handles filter option loading, selection, and download logic.
 *
 * Props:
 * - type: Type of user for filtering and download
 */

const DwonloadFilter = ({ type }) => {
    //const { updateState } = useQueryRequest()
    const [filterOption, setFilterOption] = useState([])
    const [role, setRole] = useState()
    //const [lastLogin, setLastLogin] = useState()
    const [loader, setLoader] = useState(false)
    const [progress, setProgress] = useState(0) // New: Progress bar state
    const progressIntervalRef = useRef(null)

    useEffect(() => {
        getFilter()
    }, [])

    // Loads filter options for user types
    const getFilter = () => {
        getUserTypeList().then((d) => setFilterOption(d.data))
    }

    // Handles CSV file download for selected user type
    const downloadFile = () => {
        setLoader(true)
        setProgress(0)
        // Progress simulation (since we cannot get native download progress)
        if (progressIntervalRef.current) {
            clearInterval(progressIntervalRef.current)
        }
        let prog = 0
        progressIntervalRef.current = setInterval(() => {
            prog += 10
            if (prog >= 60) { // Stop at 95% until download complete
                prog = 60
                clearInterval(progressIntervalRef.current)
            }
            setProgress(prog)
        }, 120)

        downloadByUserType(role).then((d) => {
            setProgress(100)
            downloadCsv({
                data: d,
                fileName: 'users.csv',
                fileType: 'text/csv'
            });
        }).finally(() => {
            clearInterval(progressIntervalRef.current)
            setProgress(100)
            setTimeout(() => {
                setLoader(false)
                setProgress(0)
            }, 500)
        });
    }

    return (
        <>
            <div className='d-flex'>
                <select
                    className='form-select form-select-solid fw-semibolder w-200px me-2'
                    data-kt-select2='true'
                    data-placeholder='Select option'
                    data-allow-clear='true'
                    data-kt-user-table-filter='role'
                    data-hide-search='true'
                    onChange={(e) => setRole(e.target.value)}
                    value={role}
                >
                    <option value=''>Select User Type</option>
                    {filterOption.length > 0 &&
                        filterOption.map((type) => {
                            return <option key={type?.id} value={type?.id}>{type?.type_name?.charAt(0).toUpperCase() + type?.type_name?.slice(1)}</option>
                        })
                    }
                </select>

                <button
                    disabled={!role || loader}
                    type='button'
                    onClick={downloadFile}
                    className='btn btn-light-dark btn-sm fw-semibold px-6 me-2'
                    data-kt-menu-dismiss='true'
                    data-kt-user-table-filter='filter'
                >
                    {loader ? <Downloadloader /> : <KTSVG path='/media/icons/duotune/general/gen033.svg' className='svg-icon-2' />}
                </button>
            </div>
            {loader && (
                <div style={{ marginLeft: 10, alignSelf: 'center', width: 120, marginTop: 10 }}>
                    <div className="progress">
                        <div
                            className="progress-bar progress-bar-striped progress-bar-animated"
                            role="progressbar"
                            style={{
                                width: `${progress}%`,
                                transition: "width 0.15s",
                                background:
                                    progress < 50
                                        ? "#f44336" // red
                                        : progress < 80
                                            ? "#ffb300" // orange
                                            : "#4caf50" // green
                            }}
                            aria-valuenow={progress}
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >{progress}%</div>
                    </div>
                </div>
            )}
        </>
    )
}

export { DwonloadFilter }
